import { useEffect, useMemo, useState } from 'react';

/**
 * Paginación en cliente para reportes (misma UX que ReportePacientes).
 */
export function useClientPagination(items, initialPageSize = 10) {
    const [paginaActual, setPaginaActual] = useState(1);
    const [registrosPorPagina, setRegistrosPorPagina] = useState(initialPageSize);

    const lista = Array.isArray(items) ? items : [];
    const totalRegistros = lista.length;

    const totalPaginas = useMemo(() => {
        if (registrosPorPagina === 'all') return 1;
        return Math.max(1, Math.ceil(totalRegistros / Number(registrosPorPagina)));
    }, [totalRegistros, registrosPorPagina]);

    const paginatedItems = useMemo(() => {
        if (registrosPorPagina === 'all') return lista;
        const inicio = (paginaActual - 1) * Number(registrosPorPagina);
        return lista.slice(inicio, inicio + Number(registrosPorPagina));
    }, [lista, paginaActual, registrosPorPagina, totalRegistros]);

    const indicePrimerRegistro = registrosPorPagina === 'all'
        ? 0
        : (paginaActual - 1) * Number(registrosPorPagina);

    const indiceUltimoRegistro = registrosPorPagina === 'all'
        ? totalRegistros
        : Math.min(paginaActual * Number(registrosPorPagina), totalRegistros);

    useEffect(() => {
        setPaginaActual(1);
    }, [items]);

    useEffect(() => {
        if (paginaActual > totalPaginas) {
            setPaginaActual(totalPaginas);
        }
    }, [paginaActual, totalPaginas]);

    const cambiarPagina = (numeroPagina) => {
        if (numeroPagina < 1 || numeroPagina > totalPaginas) return;
        setPaginaActual(numeroPagina);
    };

    const handlePageSizeChange = (e) => {
        const valor = e.target.value === 'all' ? 'all' : Number(e.target.value);
        setRegistrosPorPagina(valor);
        setPaginaActual(1);
    };

    return {
        paginatedItems,
        paginaActual,
        cambiarPagina,
        registrosPorPagina,
        handlePageSizeChange,
        totalPaginas,
        indicePrimerRegistro,
        indiceUltimoRegistro,
        totalRegistros,
    };
}
